import React, { useMemo, useState } from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { getAllPartnersList } from '../../../../../../../../redux/fetchActions/legadoPage/clientsApp';
import { setPartnerOption } from '../../../../../../../../redux/fetchActions/legadoPage/outstandingDebitsApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';
import GetPartners from './components/GetPartners';

function SetPartner() {
  const dispatch = useDispatch();
  const [isDisable, setIsDisable] = useState(true);

  const profileUserState = useSelector(
    (reducer: IReducer) => reducer.userProfile
  );
  const profilePartnerState = useSelector(
    (reducer: IReducer) => reducer.partnerProfile
  );
  const filterState = useSelector(
    (reducer: IReducer) => reducer.clientsApp.partnersList
  );
  const outstandigDebitsFilterState = useSelector(
    (reducer: IReducer) => reducer.outstandigDebitsFilter
  );

  function setAccount(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setPartnerOption(value));
  }

  const [partnerFilter, setPartnerFilter] = useState(filterState);

  useMemo(() => {
    if (profileUserState.nivel === 2) {
      dispatch(getAllPartnersList());
      setIsDisable(false);
    } else {
      setPartnerOption(profilePartnerState.idLegado.toString());
      setIsDisable(true);
    }
  }, [profileUserState.nivel]);

  useMemo(() => {
    if (filterState !== []) {
      setPartnerFilter(filterState);
    }
  }, [filterState]);

  return (
    <Wrapper.Default isActive={!isDisable} flexDirection="row">
      <span>Parceiro:</span>
      <Form.Control
        as="select"
        style={{ width: '11rem', margin: '0 1rem 0 0.25rem' }}
        value={outstandigDebitsFilterState.partner}
        onChange={(event) => setAccount(event)}>
        <option key={0} value={0}>
          Global (382)
        </option>

        <GetPartners partnerFilter={partnerFilter} />
      </Form.Control>
    </Wrapper.Default>
  );
}

export default SetPartner;
